/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'ホーム',
	myContent: '個人用コンテンツ',
	teamContent: 'チーム・コンテンツ',
	folder: 'フォルダー',
	files: 'ファイル',
	actionMenu: '「操作」メニュー\n',
	myFolder: '個人用フォルダー',

	emptyFolderNoContent: 'なし',

	//EmptyStates
	emptyRecentTitle: '最近表示したコンテンツはありません。',
	emptyStateTitle: 'データを追加して開始する',
	emptyStateBody: '上にある「データのアップロード」をクリックするか、ドラッグ・アンド・ドロップしてデータをアップロードします。',
	emptySearchResultTitle: '検索で結果が返されませんでした。',
	emptyPortalTitle: 'ポータルなし',
	emptyPortalBody: '現在、ポータルはありません。',
	emptyWsProjectTitle: 'Watson Studio でノートブックを作成して開始します。',
	emptyWsProjectBody: 'Cognos Analytics に戻ると、ここにノートブックが表示されます。',
	emptyFilteredResultTitle: '適用されたフィルターでは結果が返されませんでした。',
	emptyDialogViewTitle: 'アイテムはありません',
	removeFromRecents: '最近使用した項目から削除',

	// Welcome Banner
	welcomeBannerGreeting: 'こんにちは。Cognos Analytics へようこそ。',
	welcomeBannerDescription: 'Cognos Analytics は、AI 駆動型のセルフサービス分析でユーザーを支援します。データ準備の自動化、データ・ディスカバリー、視覚化によって、どのように確信をもった意思決定を推進できるかをご覧ください。',
	welcomeBannerDescription_trialUser: '入門ビデオ、製品ツアー、「ご利用の手引き」タブを参照すれば、すぐに開始できます。',
	takeTourButtonLabel: '製品ツアーを見る',
	watchVideoButtonLabel: 'ビデオを見る',
	// confirmation dialog
	hideWelcomeBannerMsg: 'ホーム・ページでようこそバナーを非表示にしますか? 「プロファイルと設定」>「設定」>「全般」でいつでも有効に戻すことができます。',
	hideWelcomeBannerTitle: 'ようこそバナーをオフにする',
	ok: 'OK',
	cancel: 'キャンセル',
	//howto video dialog
	modal_how_title: '操作説明のビデオ',
	modal_overview_title: 'Cognos Analytics の概要を見る',
	modal_how_play: '動画の再生',
	modal_how_video_title_overview: '概要',
	modal_how_video_title_getStarted: '11.2 で開始しています',
	modal_how_video_title_newUI: '新しい Cognos エクスペリエンスへようこそ',
	modal_how_video_title_dataModule: 'データ・モジュールの概要',
	modal_how_video_title_explore: 'データ閲覧ビューの概要',
	modal_how_video_title_dashboard: 'インタラクティブ・ダッシュボードの概要',
	modal_how_video_title_reporting: 'レポート作成の概要',
	modal_how_video_title_mobile: '手のひらサイズの Cognos のパワー',

	// Toolbar
	search: '検索',
	addFolder: 'フォルダーの追加',
	addLink: 'リンクの追加',
	filter: 'フィルター',
	sort: 'ソート',
	settings: '設定',
	tilesView: '並べて表示',
	listView: 'リスト・ビュー',
	columnView: '列表示',

	// Toolbar Actions
	sortBy: 'ソート基準',
	sortOrder: '順序',
	name: '名前',
	modifiedTime: '変更日時',
	type: 'タイプ',
	ascending: '昇順',
	descending: '降順',

	filterType: 'タイプ',
	filterModificationTime: '変更日時',
	all: 'すべて',
	today: '今日',
	yesterday: '昨日',
	pastWeek: '過去 1 週間',
	pastMonth: '過去 1 カ月',
	resetFilters: 'フィルターのリセット',

	filterSearchPlaceHolder: 'キーワードによるフィルター操作',

	resetFilterTag: 'X をクリックしてフィルターをリセットします。',
	filterTagToolTip: 'フィルターが適用されています: %{appliedFilters}。',

	folderName: 'フォルダー名',
	addAFolder: 'フォルダーの追加',
	add: '追加',
	error: 'エラー',
	newFolderDefaultName: 'フォルダーの新規作成',
	toastCreateNewFolder: '%{nameOfFolder} フォルダーが %{tabName} に作成されました。',
	folderAdded: 'フォルダーが追加されました',
	refresh: '更新',
	openFolder: 'フォルダーを開く',

	addAUrl: 'URL の追加',
	linkName: 'URL 名',
	linkNamePlaceholder: 'URL 名の追加',
	linkDescription: '説明 (オプション)',
	linkDescriptionPlaceholder: '説明を追加',
	linkUri: 'URL',
	linkUriPlaceholder: '使用可能なドメインの URL を追加してください',
	acceptableDomains: '使用可能なドメイン',
	viewAcceptableDomains: '使用可能なドメインを表示',
	mandatoryField: '必須フィールド',
	linkAdded: 'URL が追加されました',
	toastCreateNewLink: '%{nameOfLink} が %{tabName} に追加されました。',
	noEntries: '使用可能なドメインのリストにエントリーがありません。 管理者に連絡してください。',

	compact: 'コンパクト',
	short: '短い形式',
	default: 'デフォルト',
	rowSize: '行サイズ',

	// GroupyByTypes
	folders: 'フォルダー',
	reports: 'レポート',
	dashboards: 'ダッシュボード',
	data: 'データ',
	packages: 'パッケージ',
	explorations: '閲覧ビュー',
	stories: 'ストーリー',
	notebooks: 'ノートブック',
	others: 'その他',

	// Error Messages
	itemsOverLimit: '指定された名前 "%{itemName}" が最大値 (20) の制限を超えています。続行するには、別の名前を指定してください。',
	errorMessageLengthFolderName: 'フォルダー名を 255 文字以内で入力してください。',
	errorMessageLengthLinkName: 'リンク名を 255 文字以内で入力してください。',
	toastLaunchPerspectiveError: '%{objectType} を開けません。',
	errorNoAccessTitle: 'このコンテンツに対するアクセス権がない可能性があります',
	errorNoAccessBody: '管理者に問い合わせるか、以下のリンクを参照してください。',
	errorEnableExternalContent: '外部コンテンツの有効化',

	//TableHeader
	lastModified: '最終変更',
	location: '場所',
	tenant: 'テナント',

	// GetStartedTab
	getStartedLabel: 'IBM Cognos Analytics で実行する',
	learningHowToLabel: '学習リソース',
	learningHowToDescription: 'コミュニティーとつながったり、資料を参照したり、ビデオを見たりすることで、知識を深めたり支援を受けたりすることができます。',
	learningHowToActionLabel: '学習ペインを起動する',
	howToVideosLabel: '操作説明の動画',
	howToVideosDescription: 'IBM Cognos Analytics を使用してデータに関する洞察を得る方法について学びます。',
	howToVideosActionLabel: 'ビデオを見る',
	acceleratorCatalogLabel: 'アクセラレーター・カタログ',
	acceleratorCatalogDescription: '産業使用、ベスト・プラクティス・ガイド、カスタムの視覚化など、ますます内容が充実しているカタログをご覧いただけます。',
	acceleratorCatalogActionLabel: 'カタログの参照',
	sampleSectionTitle: 'サンプル',
	sampleSectionDescription: 'いくつかの例を試して、Cognos Analytics が提供しているさまざまな機能をご確認ください。',
	// Samples Section
	createDashboardSampleTitle: '最初のダッシュボードの作成方法',
	createDashboardSampleDescription: 'Cognos Dashboard を使用して分析を開始します。',
	covid19SampleTitle: 'COVID ダッシュボード',
	covid19SampleDescription: 'COVID-19 関連のデータを分析するこの Cognos Dashboard とカスタム拡張によって実現可能なことを探索します。',
	sankeySampleTitle: 'サンキー',
	sankeySampleDescription: 'サンキー・グラフのようなカスタム視覚化を使用して視覚化ライブラリーを拡張します。',
	viewAllSamplesActionLabel: 'すべてのサンプルを表示',
	byFeatureTitle: '機能別',
	byFeatureDescription: '中核となる機能、カスタム・コントロール、拡張機能、ノートブック、相対日付といった機能ごとにサンプルを参照します。',
	byIndustryTitle: '業種別',
	byIndustryDescription: '自動車、金融などの業種ごとにサンプルを参照します。',
	// SamplesTab
	sampleTabTitle: '構築済みのサンプルからヒントを得る',
	sampleTabLabel: 'Accelerator Catalog で IBM、パートナー様、およびお客様が作成したサンプルや拡張をさらに見る',

	// quickLaunch
	quickLaunchLabel: 'クイック起動',
	expand: '展開',
	collapse: '省略',

	// quickLaunch dialog
	quickLaunchModalLabel: '作成したいものを選択して開始します。',

	// contentPageView
	contentPageTitleLabel: 'コンテンツ',
	uploadFile: 'データのアップロード',
	new: '新規',
	create: '作成',
	more: '詳細表示',

	// open dialog
	selectDataSourcesToAdd: '追加するデータ・ソースを選択します。',
	openDialogDefaultTitle: '開く',

	// save dialog
	save: '保存',
	saveAs: '名前を付けて保存',
	saving: '保存しています...',
	selectedDestination: '選択された宛先: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' は異なるタイプで既に存在しています。別の名前を選択してください。',
	confirmOverwriteTitle: '既存のデータの置換の確認',
	confirmOverwriteMsg: 'ファイル \'%{nameOfFile}\' は、既に存在しています。そのデータを、選択されたファイルに含まれるデータに置換しますか?',

	// copy move dialog
	copy: 'コピー',
	move: '移動',
	copyOrMove: '次の場所へコピーまたは移動: ',
	copyOnly: 'コピー',
	createShortcut: 'ショートカットの作成',
	createShortcutDialogTitle: 'ショートカットの作成: ',

	// External asset types
	wsProject: 'Watson Studio プロジェクト',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'パッケージ',
	dataModule: 'データ・モジュール',
	exploration: '閲覧ビュー',
	mode: 'モード',
	live: 'ライブ',
	snapshot: 'スナップショット',
	noSnapshotsFound: 'スナップショットが見つかりませんでした',
	uploadedFile: 'アップロード・ファイル',
	fileUpload: 'データのアップロード',
	dataSetEx: 'データ・セット',
	externalRepository: '外部リポジトリー',
	queryMode: 'クエリー・モード',
	queryModeCompatible: '互換',
	queryModeDynamic: '動的',
	report: 'レポート',
	activeReport: 'アクティブ・レポート',
	query: 'クエリー',
	analysis: '分析',
	dashboard: 'ダッシュボード',
	dashboardTemplate: 'ダッシュボード・テンプレート\n',
	jupyterNotebook: 'ノートブック',
	wsNotebook: 'Watson Studio ノートブック',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'ストーリー',
	workspace: 'ワークスペース',
	pagelet: 'ページ',
	content: 'コンテンツ',
	directory: 'ネームスペース',
	dataSet: 'データ・セット',
	powerPlayCube: 'PowerPlay キューブ',
	powerPlayReport: 'PowerPlay レポート',
	powerPlay8Report: 'PowerPlay レポート',
	powerPlay8ReportView: 'PowerPlay レポート・ビュー',
	reportTemplate: 'レポート・テンプレート',
	packageConfigurations: 'パッケージ設定',
	agent: 'エージェント',
	agentDefinition: 'エージェント定義',
	agentDefinitionView: 'エージェント・ビュー',
	dataMovementTask: 'データの移動タスク',
	dataMovementTaskAlias: 'データの移動タスクの別名',
	document: '文書',
	DocumentRetention: '文書プロパティー',
	jobDefinition: 'ジョブの定義',
	job: 'ジョブ',
	metricsDataSourceETLTask: '評価指標データ・ソース ETL タスク',
	metricsExportTask: '評価指標エクスポート・タスク',
	metricsFileImportTask: '評価指標ファイル・インポート・タスク',
	metricsMaintenanceTask: '評価指標保守タスク',
	planningTask: 'Planning タスク',
	shortcut: 'ショートカット',
	URL: 'URL',
	launchable: '起動可能',
	dataSetFolder: 'データ・セット・フォルダー',
	ViewAccessibleLabel: '%{label} の表示',
	overrideReportOptions: 'デフォルトのレポート・オプションをオーバーライド',
	formats: '形式',
	saveReport: 'レポートを保存',
	promptForValues: 'プロンプトを表示',
	reportView: 'レポート・ビュー',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel データ',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: '詳細',
	open: '開く',
	created: '作成日時',
	modified: '変更日時',
	owner: '所有者',
	dataSource: 'データ・ソース',
	share: '共有',
	addToFavorites: 'お気に入りに追加',
	properties: 'プロパティー',
	detailsEmptyStateBody: '詳細を表示するアイテムを選択する',
	editNameAndDescription: '名前および説明の編集',
	none: 'なし',

	//rename dialog
	nameInvalid: '名前が無効です',
	namePlaceholder: '名前を入力します',
	description: '説明',
	descriptionInvalid: '説明は 350 文字を超えてはいけません。',
	descriptionPlaceholder: '説明を入力してください',
	errorMessageApostropheError: '\' と " の文字が両方とも含まれていないファイル名を入力してください',
	renameCollisionError: '%{name} は既に存在します。別の名前を試してください。',
	unknownRenameError: 'アイテムの名前変更に失敗しました。詳細については管理者にお問い合わせください。',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: '指定されたフォルダーを開けません。',

	//Upload
	uploadToFolder: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction} にアップロード",
	uploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> にアップロードして %{launchAction} を起動",
	quickUpload: "クイック・アップロード",
	quickUploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> にアップロードし、次のいずれかのスペースで開くファイルをドラッグ・アンド・ドロップします。",
	unsupportedFilesSingle: "%{files} はクイック起動では無効なため、アップロードされませんでした。",
	unsupportedFilesMultiple: "ファイルはアップロードされませんでした。選択するファイルはすべてクイック起動を使用できるものでなければなりません。",
	unsupportedFilesSingleInvalid: "%{files} は無効です。",
	unsupportedFilesMultipleInvalid: "%{files} は無効です。",
	supportedFileTypes: "次のファイル・タイプのみが許可されます: %{extensions}。",
	uploadDragAndDrop: "ドラッグ・アンド・ドロップ",
	uploadDragAndDropMessage: "ファイルをここにドラッグ・アンド・ドロップして、<span class=\"homeUploadFolder\"><span id=\"homeUploadFolderName\">{folderName}</span></span> にアップロードしてください。",

	// searchBar
	searchWasSaved: '検索条件 \'%{searchTerm}\' が保存されました。',
	searchWasntSaved: '検索条件 \'%{searchTerm}\' は保存されませんでした。',
	searchSuggestions: '候補',
	savedSearch: '保存されている検索',
	searchWasDeleted: '検索条件 \'%{searchTerm}\' が削除されました。',
	searchWasntDeleted: '検索条件 \'%{searchTerm}\' は削除されませんでした。',
	savedBarTitle: 'Cognos Analytics の検索',
	searchContentPageTitle: '検索',
	searchContentPageTitleLabel: '\'%{searchTerm}\' の結果を表示',
	showingSearchRsult: '%{resultCount} 個のアイテムを表示中',
	saveSearch: '検索を保存',
	saveTenSearches: '保存できる検索は 10 までです。',
	deleteASearch: '別のものを保存するには、1 つ削除してください。',
	close: '閉じる',

	//recent view
	recents: '最近使用した項目',
	noAccessRecent: 'アクセスできません',
	noAccessRecentMsg: 'この資産にアクセスできません。 資産が無効化または削除された可能性があります。または権限が降格された可能性があります。 この資産の状態を、その所定のソースの場所で確認してください。 「OK」をクリックすると、最近使用した項目からこの資産を削除できます。',
	noAccessMsg: 'この資産にアクセスできません。 資産が無効化または削除された可能性があります。または権限が降格された可能性があります。 ',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} 個のアイテムが選択されました',
	itemSelected: '%{nameOfSelection} 個のアイテムが選択されました'

});